"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesTags = void 0;
class FilesTags {
    constructor() { }
}
exports.FilesTags = FilesTags;
FilesTags.ImgMain = "main_image";
//# sourceMappingURL=FilesTags.js.map